import styled from 'styled-components';

import { font, mixin } from 'utils/styles';

export const List = styled.div`
  display: flex;
  flex-direction: column;
  margin: 0 5px;
  max-height: 75vh;
  height: calc(100vh - 240px);
  width: 25%;
  min-width: 210px;
  border-radius: 6px;
  background: ${(props) => props.theme.palette.surface.main};

  /* Responsive height breakpoints */
  @media (max-height: 900px) {
    height: calc(100vh - 260px);
  }
`;

export const Title = styled.div`
  padding: 13px 10px 17px;
  text-transform: uppercase;
  color: ${(props) => props.theme.palette.text.main};
  margin: auto;
  ${font.size(12.5)};
  ${mixin.truncateText}
`;

export const IssuesCount = styled.span`
  text-transform: lowercase;
  ${font.size(13)};
`;

export const Issues = styled.div`
  height: 100%;
  padding: 0 5px;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
  ${mixin.simpleCustomScrollbar}
`;

export const UpdateText = styled.div`
  ${font.size(14)};
  color: ${(props) => props.theme.palette.text.main};
  padding-bottom: 10px;
`;

export const ExtraItemsBlock = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 20px 0;
`;
